// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1KC80","footer":"Form_footer__3CnRW"};